export default __webpack_public_path__ + "static/media/grid.011.a8f2e608.jpeg";